import { Form as FormContainer } from 'components/Form'
import { Form } from './Form'
import { schema, schemaDefaults } from './schema'
import { useCreateReport } from './useCreateReport'

import type { Schema } from './schema'
import type { GenerateReportFormProps } from './types'

const FORM_ID: string = 'yieldbird-wrapper-agent-generate-report-form'

export const GenerateReportForm = ({
  disabled,
  onCreated,
}: GenerateReportFormProps): React.JSX.Element => {
  const { create, errors: apiErrors, isPending } = useCreateReport({ onCreated })

  return (
    <FormContainer<Schema>
      externalErrors={apiErrors}
      id={FORM_ID}
      onSubmit={create}
      schema={schema}
      schemaDefaults={schemaDefaults}
      withLeaveDialog={false}
    >
      {() => (
        <Form
          disabled={disabled || isPending}
          formId={FORM_ID}
        />
      )}
    </FormContainer>
  )
}
